import { Component, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { WestnetzSidenavService } from '../../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
    selector: 'tnb-westnetz-page',
    templateUrl: './westnetz-page.component.html',
    styleUrls: [
        './westnetz-page.component.scss',
    ],
    standalone: false,
})
export class WestnetzPageComponent {
    private westnetzSidenavService = inject(WestnetzSidenavService);

    @ViewChild('right', { static: true }) right: MatSidenav;
    @ViewChild('rightTemplate', { read: ViewContainerRef, static: true }) rightTemplateContainer: ViewContainerRef;

    constructor() {
        this.westnetzSidenavService.openRightnav$.subscribe(component => {
            this.rightTemplateContainer.clear();
            this.rightTemplateContainer.createComponent(component);
            this.right.open();
        });

        this.westnetzSidenavService.closeRightnav$.subscribe(() => {
            this.right.close().then(() => this.rightTemplateContainer.clear());
        });
    }
}
